/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import toLower from 'ramda/src/toLower'
import withStyles from '@material-ui/core/styles/withStyles'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import classNames from 'classnames'
import goToViewCreatorDataHandler from 'root/src/client/logic/creatorData/handlers/goToViewCreatorDataHandler'
import assigneeRouteSelector from 'root/src/client/logic/project/util/assigneeRouteSelector'
import Typography, { typographyVariants } from 'root/src/client/web/typography/Typography'
import { colorsNew, dropShadow, boxShadow, ltGtMediaQuery } from 'root/src/client/web/commonStyles'

const style = {
	root: {
		backgroundColor: colorsNew.dark2,
		margin: [[0, 10, 20]],
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignSelf: 'center',
		position: 'relative',
		borderRadius: 30,
		transition: '0.1s',
		alignItems: 'center',
		width: 420,
		maxWidth: 372,
		minWidth: 300,
		[ltGtMediaQuery]: {
			width: '80vw',
		},
	},
	descriptionContainer: {
		textAlign: 'center',
		padding: [[30, 40, 10, 40]],
	},
	creatorDataContainer: {
		margin: [[0, 0, 10]],
	},
	avatarContainer: {
		position: 'absolute',
		bottom: 0,
		left: '50%',
		transform: 'translate(-50%, 50%)',
	},
	nameContainer: {
		textAlign: 'center',
		marginBottom: 60,
	},
}

export const TestimonialCard = ({
	description, name, title, image, color, className, classes,
}) => (
	<div className={classNames(classes.root, className)}>
		<div className={classes.descriptionContainer}>
			<Typography
				variant={typographyVariants.heading4}
			>{description}
			</Typography>
		</div>
		<div
			className={classes.creatorDataContainer}
			onClick={() => goToViewCreatorDataHandler(
				assigneeRouteSelector({
					mnemonicId: toLower(name),
					displayName: name,
					platform: 'twitch',
				}),
			)}
		>
			<div className={classes.nameContainer}>
				<Typography
					variant={typographyVariants.small}
					color={color}
				>{name}, {title}
				</Typography>
			</div>
		</div>
		<div className={classes.avatarContainer}>
			<LazyLoadImage
				css={{
					borderRadius: '50%',
					border: '3px solid #fff',
					boxShadow: boxShadow(color),
					dropShadow: dropShadow(color),
					width: 80,
					height: 80,
					boxSizing: 'border-box',
					padding: 6,
				}}
				src={image.src}
				alt={name}
			/>
		</div>
	</div>
)

export default withStyles(style, { name: 'MuiTestimonialCard' })(TestimonialCard)
